<template>
    <SelectPackageCard
        :allMemberships="[]"
        :myMemberships="eligibleGroupPackages"
        :selectedUserPkg="props.selectedUserPkg"
        @onSelectPackage="updateSelectedPackage"
        hideHint
        dropdownHintType="group"
        :user="props.user"
        :studioClass="props.studioClass"
        bookingType="group"
    />
</template>

<script setup lang="ts">
import { type Package, type StudioClass, type User } from './types/types'
import { computed } from 'vue'
import SelectPackageCard from './SelectPackageCard.vue'

const props = defineProps<{
    allMemberships: Package[]
    myMemberships: Package[]
    selectedUserPkg: Package | undefined
    user: User
    studioClass: StudioClass
}>()

const eligibleGroupPackages = computed(() => {
    return props.myMemberships.filter((x) => x.isGroupBookable)
})

const emit = defineEmits<{
    (e: 'onSelectPackage', pkg: Package, isMyPackage: boolean): void
}>()

const updateSelectedPackage = (
    selectedPackage: Package,
    isMyPackage: boolean
) => {
    emit('onSelectPackage', selectedPackage, isMyPackage)
}
</script>
